<template>
    <div class="forum-avatar">
        <img
            class="avatar"
            :src="src"
            v-if="src">
        <div
            class="avatar-icon"
            v-else>
            <i class="fa fa-user"></i>
        </div>
    </div>
</template>

<script>
    // ForumAvatar: a profile picture widget for a forum user. Displays a
    // default avatar if no url is provided.

    export default {
        props: {
            // URL for avatar. A default will be used if not supplied.
            src: {
                type: String,
                required: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .forum-avatar {
        width: 50px;
        height: 50px;
        font-size: 48px;

        background: #111;
        border-radius: 50%;
        overflow: hidden;
    }

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .avatar-icon {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        border: 2px solid #111;
        border-radius: 50%;
        overflow: hidden;

        i {
            color: #b0b0b0;
            display: block;
            transform: translateY(17%);
        }
    }
</style>



// WEBPACK FOOTER //
// avatar.vue?82a0781e